<template>
  <form
    class="contact-search-form col-lg-9 col-xl-8 col-xxl-7"
    @submit.prevent="$emit('submit')"
  >
    <input
      type="search"
      name="term"
      class="contact-search-form__input form-control"
      placeholder="Search for contacts, trading teams and more..."
      aria-label="Search for contacts, trading teams and more"
      :value="value"
      @change="$emit('change', $event.target.value)"
    >

    <button
      type="submit"
      class="contact-search-form__btn btn btn-blue"
    >
      Search
    </button>
  </form>
</template>

<script>
export default {
  name: 'ContactSearchForm',

  model: {
    prop: 'value',
    event: 'change',
  },

  props: {
    value: String,
  },
}
</script>

